import { render, staticRenderFns } from "./UpdateSelectedClientStatus.vue?vue&type=template&id=c010057c&"
import script from "./UpdateSelectedClientStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateSelectedClientStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports